import { Dispatch, FC, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { AppDialog } from "@/components/common";
import { LangConstant } from "@/const";
import SelectedFiles from "@/components/common/dialog/ImportDialog/SelectedFiles";
import LoadingDecryptDialog from "@/components/common/dialog/LoadingDecryptDialog";
import DialogSelectFolder from "@/components/common/dialog/DialogSelectFolder";

type ViolationResponseImportDialogProps = {
  onImport: () => void;
  filesUpload: File[];
  openUpload: boolean;
  onChangeOpenUpload: Dispatch<SetStateAction<boolean>>;
};

const ViolationResponseImportDialog: FC<ViolationResponseImportDialogProps> = ({
  onImport,
  filesUpload,
  openUpload,
  onChangeOpenUpload,
}) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);
  const [isOpenDecryptDialog, setIsOpenDecryptDialog] = useState<boolean>(false);
  const [isOpenSelectFolder, setIsOpenSelectFolder] = useState<boolean>(false);

  const handleImport = () => {
    onImport();
    setIsOpenDecryptDialog(false);
  };

  const handleOpenSelectFolder = () => {
    setIsOpenSelectFolder(true);
  };

  const handleCloseSelectFolder = () => {
    setIsOpenSelectFolder(false);
  };

  const handleOpenDecryptDialog = () => {
    setIsOpenSelectFolder(false);
    setIsOpenDecryptDialog(true);
  };

  return (
    <>
      <AppDialog
        open={openUpload}
        title={getLabel("OBJ_EXTERNAL_IMPORT.title")}
        onClose={() => {
          onChangeOpenUpload(false);
        }}
        ConfirmButtonProps={{
          label: getLabel("L_CONFIRM"),
          onClick: handleOpenSelectFolder,
        }}
        CancelButtonProps={{
          label: getLabel("L_CANCEL"),
        }}
      >
        <Typography variant="subtitle1">{getLabel("OBJ_EXTERNAL_IMPORT.listImport")}</Typography>
        <SelectedFiles files={filesUpload} showFile />
      </AppDialog>
      <DialogSelectFolder
        open={isOpenSelectFolder}
        onClose={handleCloseSelectFolder}
        onSubmit={handleOpenDecryptDialog}
      />
      <LoadingDecryptDialog open={isOpenDecryptDialog} onClose={handleImport} />
    </>
  );
};
export default ViolationResponseImportDialog;
